import { ITourismEvents } from "../models/ITourismEvents";

export default function getTourismEvents(
  contentId: number,
  page: number = 1,
  eventType: Array<string>,
  search: string,
  dateFrom: string,
  dateTo: string
): Promise<ITourismEvents> {
  const params = {
    contentId,
    page,
    eventType,
    search,
    dateFrom,
    dateTo
  };

  return fetch("/api/TourismEventsApi/GetData", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(params)
  })
    .then((e) => e.json())
    .then((result) => result);
}
